import React from 'react';

const FloatingContact = () => {
  const phoneNumber = "923128337788"; // Replace with your actual number
  const whatsappMsg = encodeURIComponent("Hello Ehsan Traders! I'm interested in a project.");

  return (
    <>
      {/* DESKTOP VIEW: Floating Buttons (Bottom Right) */}
      <div className="hidden lg:flex fixed bottom-8 right-8 z-[100] flex-col space-y-4">
        <a 
          href={`https://wa.me/${phoneNumber}?text=${whatsappMsg}`}
          className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-2xl hover:-translate-y-2 transition-all duration-300 group"
        >
          <i className="fab fa-whatsapp text-3xl"></i>
          <span className="absolute right-16 bg-[#0A1D37] text-white px-4 py-2 rounded text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            WhatsApp Us
          </span>
        </a>
        <a 
          href={`tel:+${phoneNumber}`}
          className="w-14 h-14 bg-[#0A1D37] text-white rounded-full flex items-center justify-center shadow-2xl hover:-translate-y-2 transition-all duration-300 group border border-white/10"
        >
          <i className="fas fa-phone-alt text-xl"></i>
          <span className="absolute right-16 bg-[#0A1D37] text-white px-4 py-2 rounded text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            Call Support
          </span>
        </a>
      </div>

      {/* MOBILE VIEW: Fixed Bottom Action Bar */}
      <div className="lg:hidden fixed bottom-0 left-0 w-full h-16 bg-white border-t border-slate-200 z-[100] grid grid-cols-2 shadow-[0_-5px_20px_rgba(0,0,0,0.05)]">
        <a 
          href={`tel:+${phoneNumber}`}
          className="flex items-center justify-center space-x-3 text-[#0A1D37] active:bg-slate-50 transition-colors"
        >
          <i className="fas fa-phone-alt text-[#D62828]"></i>
          <span className="text-xs font-black uppercase tracking-widest">Call Now</span>
        </a>
        
        <a 
          href={`https://wa.me/${phoneNumber}?text=${whatsappMsg}`}
          className="flex items-center justify-center space-x-3 bg-[#25D366] text-white active:opacity-90 transition-opacity"
        >
          <i className="fab fa-whatsapp text-xl"></i>
          <span className="text-xs font-black uppercase tracking-widest">WhatsApp</span>
        </a>
      </div>
    </>
  );
};

export default FloatingContact;